<template>
  <label class="switch-container my-3" :id="'switch-container-' + id">
    <input
      type="checkbox"
      @change="updateValue"
      :checked="value"
      :disabled="disabled"
      :id="id"
    />
    <b-tooltip :placement="tooltipPosition" :target="'switch-container-' + id"
      >Não / Sim
    </b-tooltip>
    <span class="container-align">
      <span class="text" v-if="position === 'top'">{{ label }}</span>
      <span class="switch" :class="switchClass"></span>
      <span class="text" v-if="position === 'bottom'">{{ label }}</span>
    </span>
  </label>
</template>

<script>
export default {
  name: 'CheckboxSwitch',
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    value: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    position: {
      type: String,
      validator: () => ['top', 'bottom'],
      default: 'bottom',
    },
    tooltipPosition: {
      type: String,
      validator: () => ['top', 'bottom'],
      default: 'top',
    },
  },
  methods: {
    updateValue() {
      this.$emit('input', !this.value);
    },
  },
  computed: {
    switchClass() {
      return {
        disabled: this.disabled,
        checked: this.value,
      };
    },
  },
};
</script>
